import { type VariantProps, tv } from 'tailwind-variants';

import type { CommonProps } from '../../types';
import { FormInputGroup } from '../../molecules';

import type { JSX } from 'react';

export interface FormTextareaProps
    extends CommonProps,
        VariantProps<typeof FormTextareaStyles> {
    id: string;
    name?: string;
    type?: 'text' | 'email';
    label: string;
    isDisabled?: boolean;
    hasErrors?: boolean;
    wrapperClassName?: string;
    required?: boolean;
    defaultValue?: string;
}
export const FormTextareaStyles = tv({
    slots: {
        input: 'block rounded-xl bg-gray-500 peer py-2 px-5 peer w-full',
        label: 'absolute top-0 left-2 text-gray-100 text-sm peer-placeholder-shown:text-base peer-placeholder-shown:translate-x-3 peer-placeholder-shown:translate-y-9 transition',
    },
    variants: {
        labelHidden: {
            true: {
                label: 'sr-only',
                input: 'placeholder:text-gray-100',
            },
            false: {
                input: 'mt-7 placeholder-transparent',
            },
        },
        hasValue: {
            true: {
                label: '',
            },
        },
        hasErrors: {
            true: {
                input: 'border-danger-500 border',
                label: 'text-danger-500',
            },
            false: {},
        },
        required: {
            true: {
                label: "after:content-['*']",
            },
        },
    },
});
export const FormTextarea = ({
    className,
    id,
    name,
    testId = 'form-textarea',
    labelHidden,
    label,
    isDisabled,
    required,
    wrapperClassName,
    defaultValue,
    hasErrors = false,
}: FormTextareaProps): JSX.Element => {
    const { label: labelStyles, input } = FormTextareaStyles({
        labelHidden,
        hasErrors,
    });
    return (
        <FormInputGroup className={wrapperClassName}>
            <textarea
                data-testid={testId}
                className={input({ className })}
                id={id}
                name={name ?? id}
                placeholder={`${label}${required && labelHidden ? '*' : ''}`}
                rows={7}
                defaultValue={defaultValue}
                {...(required && { required })}
                {...(isDisabled && { disabled: isDisabled })}
            ></textarea>
            <label className={labelStyles({ required })} htmlFor={id}>
                {label}
            </label>
        </FormInputGroup>
    );
};
